let timer = null;
let isInitialized = false;

const handleStorageChange = (e) => {
  // Handles cross-tab sync only
  if (e.key === 'temp_token' || e.key === 'start_time') {
    cleanup();
    checkAndSetupExpiry();
  }
};

const expireToken = () => {
  localStorage.removeItem('temp_token');
  localStorage.removeItem('start_time');

  // Dispatch event so app can react (show popup, redirect etc.)
  window.dispatchEvent(new CustomEvent('tempTokenExpired'));

  cleanup();
};

const cleanup = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
};

const checkAndSetupExpiry = () => {
  const tempToken = localStorage.getItem('temp_token');
  const startTime = localStorage.getItem('start_time');

  if (!tempToken || !startTime) {
    return;
  }

  const startDate = new Date(startTime);

  // ✅ Bug 1 Fixed — invalid date check
  if (isNaN(startDate.getTime())) {
    console.warn('Invalid start_time in localStorage, clearing temp session');
    expireToken();
    return;
  }

  const currentDate = new Date();
  const diffInMs = currentDate - startDate;

  // ✅ Bug 1 Fixed — was 120 * 1000 (2 minutes), now correctly 1 hour
  const oneHourInMs = 30 * 60 * 1000;

  if (diffInMs >= oneHourInMs) {
    console.log('Temp token already expired, clearing session');
    expireToken();
    return;
  }

  const remainingTime = oneHourInMs - diffInMs;

  timer = setTimeout(() => {
    expireToken();
  }, remainingTime);

  const remainingMinutes = Math.round(remainingTime / 1000 / 60);
  const remainingSeconds = Math.round(remainingTime / 1000) % 60;
  console.log(`Temp token will expire in ${remainingMinutes} minutes and ${remainingSeconds} seconds`);
};

export const initialize = () => {
  if (isInitialized) {
    return;
  }

  checkAndSetupExpiry();
  isInitialized = true;

  // ✅ Bug 3 Noted — storage event only fires in OTHER tabs, same tab handled by startNewSession()
  window.addEventListener('storage', handleStorageChange);
};

export const startNewSession = (token, startTime) => {
  // Validate inputs before saving
  if (!token || !startTime) {
    console.warn('tempTokenManager: token and startTime are required');
    return;
  }

  localStorage.setItem('temp_token', token);
  localStorage.setItem('start_time', startTime);

  // Cleanup any existing timer before starting new one
  cleanup();
  checkAndSetupExpiry();
};

// ✅ Bug 4 Fixed — helper to listen for token expiry anywhere in app
export const onTokenExpired = (callback) => {
  if (typeof callback !== 'function') {
    console.warn('onTokenExpired: callback must be a function');
    return;
  }
  window.addEventListener('tempTokenExpired', callback);
};

// Remove the expiry listener
export const offTokenExpired = (callback) => {
  window.removeEventListener('tempTokenExpired', callback);
};

export const destroy = () => {
  cleanup();
  window.removeEventListener('storage', handleStorageChange);
  isInitialized = false;
};

export const getRemainingTime = () => {
  const startTime = localStorage.getItem('start_time');
  if (!startTime) return null;

  const startDate = new Date(startTime);
  if (isNaN(startDate.getTime())) return null;

  const diffInMs = new Date() - startDate;
  const oneHourInMs = 60 * 60 * 1000;
  const remaining = oneHourInMs - diffInMs;

  return remaining > 0 ? remaining : 0;
};

const tempTokenManager = {
  initialize,
  startNewSession,
  onTokenExpired,
  offTokenExpired,
  destroy,
  getRemainingTime
};

export default tempTokenManager;